import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';

const BackdropRumbleIntensitySlider = (props) => {
    const { intensity, updateBackgroundSettings } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateBackgroundSettings({ shakeIntensity: value });
    }, [intensity, updateBackgroundSettings]);

    return (
        <SliderListItem
            title='Intensity'
            displayMultiplier={1}
            value={intensity}
            min={1}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { shakeIntensity } = state.createPreview.present.videoSettings.background;
    return {
        intensity: shakeIntensity ?? 20
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropRumbleIntensitySlider);
